import { Component, OnInit, Input, HostBinding, Output, HostListener, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-chip-notResponsive',
  templateUrl: './chip-notResponsive.component.html',
  styleUrls: ['./chip-notResponsive.component.scss']
})
export class ChipNotResponsiveComponent implements OnInit {
  @Input()
  @HostBinding('class.active') selected: boolean = false;
  @Output() select = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  @HostListener('click', ['$event.target'])onclick(btn) {
    this.select.emit(this);
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/chips/chip-notResponsive/chip-notResponsive.component.ts